import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import VoucherFormCustomer from '../../components/VoucherForm/Rules/AllowedCustomer/VoucherFormCustomer';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddCreditPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Credit',
    voucherType: 'Credit',
    reasonField: false,
    specificationLabel: 'Specification (campaign / partner name',
    specificationRequired: true,
  };

  const VoucherFormDiscountTemplate = {
    disabled: true,
    discountType: 'credit_amount',
    showFreeAncillaries: false,
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: false,
    disableValidity: false,
  };

  return (
    <>
      <VoucherFormBanner title='Credit (for partners)' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity />
            <VoucherFormStructure />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
            <VoucherFormCustomer />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddCreditPage;
